const ALL = ['cms'] as const;

export const CMS_KEYS = {
  all: ALL,
  // CMS submission poll, keyed per-operation so the eligibility and align polls
  // never collide and serve each other's rows. Sits under the ['cms'] prefix so
  // CMS_KEYS.all invalidations still match.
  submissions: (op: string, withingsUserId: string) => [...ALL, 'submissions', op, String(withingsUserId)] as const,
  // All-operations submission read for the patient-drawer CMS card (window + in-flight
  // math). Distinct from `submissions(op,…)` — the per-op poll uses gcTime:0/staleTime:0,
  // so a shared entry would clobber the card's cache. Still under ['cms'] for invalidation.
  submissionsAll: (withingsUserId: string) => [...ALL, 'submissions', 'all', String(withingsUserId)] as const,
} as const;
